































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import { cloneDeep } from 'lodash';
import { currencyToNumber } from '@/data/utils/helper';
import { Rettifica } from '@/data/models/offer.model';

@Component({
	components: {
		ValidationObserver,
		ValidationProvider
	}
})
export default class FattorinoRettifica extends Vue {
	@Prop() model!: Rettifica;

	newModel: Rettifica;

	numberMask: any = {
		numeral: true,
		numeralDecimalMark: ',',
		delimiter: '.',
		numeralPositiveOnly: false
	};

	currencies: any = {};

	constructor() {
		super();
		this.newModel = new Rettifica();
	}

	beforeMount() {
		this.newModel = cloneDeep(this.model);
	}

	onCurrencyChange(event: any, field: string) {
		this.currencies[field] = currencyToNumber(event.target._vCleave.getFormattedValue());
	}

	submit() {
		Object.keys(this.currencies).forEach(k => {
			this.$set(this.newModel, k, this.currencies[k]);
		});
		this.$emit('submit', this.newModel);
	}

}
